const GOLD = "#F5A524";

// Booklet cover — a full 816 x 1056 (US Letter) page rendered as the first
// page of the "all 46 cards" PDF. Dark, premium, brand-forward.
export default function CoverSheet({ lang = "en", totalCards = 46, totalSets = 4 }) {
  const t = (en, es) => (lang === "es" ? es : en);
  return (
    <div
      data-sheet
      data-testid="task-sheet-cover"
      style={{
        width: 816,
        height: 1056,
        background: "linear-gradient(160deg, #1C1C20 0%, #0A0A0A 70%)",
        color: "#ffffff",
        position: "relative",
        overflow: "hidden",
        fontFamily: "'Outfit', system-ui, sans-serif",
      }}
    >
      {/* decorative motifs */}
      <div style={{ position: "absolute", right: -120, top: -120, width: 380, height: 380, borderRadius: "50%", background: `${GOLD}22` }} />
      <div style={{ position: "absolute", left: -90, bottom: 120, width: 260, height: 260, borderRadius: "50%", background: "rgba(255,255,255,0.04)" }} />
      <div style={{ position: "absolute", right: 80, bottom: -60, width: 180, height: 180, borderRadius: "50%", background: `${GOLD}18` }} />

      {/* brand row */}
      <div style={{ position: "relative", padding: "56px 64px 0", display: "flex", alignItems: "center", gap: 12 }}>
        <span style={{ width: 44, height: 44, borderRadius: 12, background: GOLD, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
          <CameraGlyph fill="#0A0A0A" size={26} />
        </span>
        <span style={{ fontWeight: 800, fontSize: 26, letterSpacing: "-0.02em" }}>DSLR Advisor&trade;</span>
      </div>

      {/* title block */}
      <div style={{ position: "relative", padding: "0 64px", marginTop: 230 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 22 }}>
          <span style={{ width: 54, height: 4, borderRadius: 2, background: GOLD }} />
          <span style={{ fontSize: 16, fontWeight: 700, letterSpacing: "0.28em", textTransform: "uppercase", color: GOLD }}>
            {t("The Complete", "La Guía Completa")}
          </span>
        </div>
        <h1 style={{ fontSize: 78, fontWeight: 800, lineHeight: 1.0, margin: 0, letterSpacing: "-0.03em" }}>
          {t("DSLR Field Guide", "Guía de Campo DSLR")}
        </h1>
        <p style={{ fontSize: 27, fontWeight: 500, color: "rgba(255,255,255,0.78)", margin: "26px 0 0", maxWidth: 600, lineHeight: 1.4 }}>
          {t(
            `${totalCards} printable cheat sheets — manual settings, composition & field craft, in your pocket.`,
            `${totalCards} hojas imprimibles — ajustes manuales, composición y trabajo de campo, en tu bolsillo.`
          )}
        </p>
      </div>

      {/* stat chips */}
      <div style={{ position: "relative", padding: "0 64px", marginTop: 60, display: "flex", gap: 16 }}>
        {[
          [String(totalCards), t("Cheat Sheets", "Hojas")],
          [String(totalSets), t("Topic Sets", "Conjuntos")],
          ["8.5×11", t("Print Ready", "Listo p/ Imprimir")],
        ].map(([big, small], i) => (
          <div key={i} style={{ flex: 1, background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 16, padding: "20px 22px" }}>
            <div style={{ fontSize: 36, fontWeight: 800, color: GOLD, letterSpacing: "-0.02em" }}>{big}</div>
            <div style={{ fontSize: 14, fontWeight: 600, color: "rgba(255,255,255,0.7)", letterSpacing: "0.05em", textTransform: "uppercase", marginTop: 4 }}>{small}</div>
          </div>
        ))}
      </div>

      {/* footer */}
      <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, padding: "26px 64px", display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <span style={{ fontSize: 16, fontWeight: 700, color: GOLD }}>★ {t("FREE printable booklet", "Folleto imprimible GRATIS")}</span>
        <span style={{ fontSize: 16, fontWeight: 600, color: "rgba(255,255,255,0.65)" }}>www.dslradvisor.com</span>
      </div>
    </div>
  );
}

function CameraGlyph({ fill = "#0A0A0A", size = 26 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 256 256" fill={fill} aria-hidden>
      <path d="M208 56h-27.7l-13.6-20.4A8 8 0 0 0 160 32H96a8 8 0 0 0-6.7 3.6L75.7 56H48a24 24 0 0 0-24 24v112a24 24 0 0 0 24 24h160a24 24 0 0 0 24-24V80a24 24 0 0 0-24-24Zm-80 128a44 44 0 1 1 44-44 44 44 0 0 1-44 44Z" />
    </svg>
  );
}
